import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function PriceChangePill({ value, suffix = 'in 12 mesi', inverse = false }) {
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  const up = number > 0;
  const down = number < 0;
  const positiveClass = inverse ? 'bg-md-success-container text-md-on-success-container' : 'bg-md-primary text-md-on-primary';
  const negativeClass = inverse ? 'bg-md-primary text-md-on-primary' : 'bg-md-success-container text-md-on-success-container';
  const Icon = up ? ArrowUpRight : down ? ArrowDownRight : Minus;
  return (
    <div className={cn('inline-flex min-h-10 items-center gap-1.5 rounded-full px-4 text-sm font-bold numbers', up ? positiveClass : down ? negativeClass : 'bg-md-surface-container-high text-md-on-surface-variant')}>
      <Icon className="h-4 w-4" />
      <span>{up ? '+' : ''}{number.toFixed(2)}%</span>
      {suffix && <span className="font-medium">{suffix}</span>}
    </div>
  );
}
